import moment from 'moment/moment';
import React from 'react'
import numberbeautify from '../../utils/numberbeautify';
import money_rounding from '../../utils/money_rounding';
import constant from '../../utils/constant';
import de from '../../utils/language_de';
import en from '../../utils/language_en';
import es from '../../utils/language_es';
import fr from '../../utils/language_fr';
import it from '../../utils/language_it';
import pt from '../../utils/language_pt';
import zh from '../../utils/language_zh';

const isEmptyString = (value) => {
  if (value == null) {
    return false;
  }
  return !(String(value).trim().length === 0);
};

const Modern_template_5 = ({document_number, business_detail, document_issue_date, document_due_date, client_detail, items, discount, discount_type, discount_amount, tax_amount, tax_type, tax_label, document_note, template, action, total_document_amount, document_tax, document_tax_amount, document_discount_type, document_discount, document_discount_amount, document_currency, document_type, user_notification_token, localization, signature_name, signature}) => {
    const business_detaill=JSON.parse(business_detail) || {};
    const itemss=JSON.parse(items) || [];
    const client_detaill=JSON.parse(client_detail) || {};
    const document_currencyy=JSON.parse(document_currency) || {};
    const templatee=JSON.parse(template) || {};
    const localizationn=localization=="zh"?zh:localization=="de"?de:localization=="en"?en:localization=="es"?es:localization=="fr"?fr:localization=="it"?it:localization=="pt"?pt:en;

    return (
        <div className="w-full" style={{backgroundColor:templatee?.selectedcolor?.primary}}>
            <div className='w-full h-[150px] md:h-[200px] lg:h-[220px] flex px-4'>
                <div className='w-1/2 h-full flex justify-start items-start relative'>
                    <div className='absolute top-0 left-[10%] w-[80%] h-full rounded-b-xl flex justify-center items-center' style={{backgroundColor:templatee?.selectedcolor?.secondary}}>
                        <div>
                            <h1 className="text-2xl md:text-4xl tracking-tight sf-semibold break-all" style={{color:templatee?.selectedcolor?.tableheadercolor}}>{document_type === 'estimate' ? localizationn?.estimate_full_capital : localizationn?.invoice_full_capital}</h1>
                            <div className='flex items-start'>
                                <p className="sf-light text-[9px] md:text-lg break-all" style={{color:templatee?.selectedcolor?.tableheadercolor}}>{document_type === 'estimate' ? localizationn?.estimate_no : localizationn?.invoice_no} &nbsp;</p>
                                <p className="sf-light text-[9px] md:text-lg break-all" style={{color:templatee?.selectedcolor?.tableheadercolor}}>{document_number}</p>
                            </div>
                            <div className='flex items-start'>
                                <p className="sf-light text-[9px] md:text-lg break-all" style={{color:templatee?.selectedcolor?.tableheadercolor}}>{localizationn?.issue_date} &nbsp;</p>
                                <p className="sf-light text-[9px] md:text-lg break-all" style={{color:templatee?.selectedcolor?.tableheadercolor}}> {moment(document_issue_date).format('MMM,DD,YYYY')}</p>
                            </div>
                            <div className='flex items-start'>
                                <p className="sf-light text-[9px] md:text-lg break-all" style={{color:templatee?.selectedcolor?.tableheadercolor}}>{document_type === 'estimate' ? localizationn?.valid_until : localizationn?.due_date} &nbsp;</p>
                                <p className="sf-light text-[9px] md:text-lg break-all" style={{color:templatee?.selectedcolor?.tableheadercolor}}> {moment(document_due_date).isValid() ? moment(document_due_date).format("MMM,DD,YYYY") : 
                                    document_due_date=="On Receipt"?localizationn?.on_receipt:
                                    document_due_date=="3 days"?localizationn?.three_days:
                                    document_due_date=="10 days"?localizationn?.ten_days:
                                    document_due_date=="30 days"?localizationn?.thirty_days:
                                    document_due_date=="No Valid Date"?localizationn?.no_valid_date:
                                    document_due_date=="No Duo Date"?localizationn?.no_duo_date:
                                    document_due_date
                                }</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='w-1/2 h-full flex justify-center items-center'>
                    {business_detaill?.business_logo.trim()?(
                        <img src={business_detaill?.business_logo} className="w-24 h-24 md:w-28 md:h-28 lg:w-32 lg:h-32" />
                    ):(
                        <div className="w-24 h-24 md:w-28 md:h-28 lg:w-32 lg:h-32" />
                    )}
                </div>
            </div>
            <div className='w-full flex justify-between mt-4 px-3'>
                <div className='w-[47%] border rounded-[8px] md:rounded-[12px] p-[10px]' style={{borderColor:templatee?.selectedcolor?.bordercolor}}>
                    <h2 className="text-base md:text-xl sf-semibold" style={{color:templatee?.selectedcolor?.secondary}}>{localizationn?.from}</h2>
                    <div className='w-full flex mt-[3px]'>
                        <div className='w-[45%] text-[8px] md:text-base' style={{color:templatee?.selectedcolor?.textcolor2}}>
                            {localizationn?.business_name}
                        </div>
                        <div className='w-[55%]'>
                            <p className="sf-regular text-[8px] md:text-base break-all" style={{color:templatee?.selectedcolor?.textcolor}}>{business_detaill?.business_name}</p>
                        </div>
                    </div>
                    {isEmptyString(business_detaill?.business_email) &&(<div className='w-full flex mt-[3px]'>
                        <div className='w-[45%] text-[8px] md:text-base' style={{color:templatee?.selectedcolor?.textcolor2}}>
                            {localizationn?.email}
                        </div>
                        <div className='w-[55%]'>
                            <p className="sf-regular text-[8px] md:text-base break-all" style={{color:templatee?.selectedcolor?.textcolor}}>{business_detaill?.business_email}</p>
                        </div>
                    </div>)}
                    {isEmptyString(business_detaill?.business_phone_1) && (<div className='w-full flex mt-[3px]'>
                        <div className='w-[45%] text-[8px] md:text-base' style={{color:templatee?.selectedcolor?.textcolor2}}>
                            {localizationn?.number_1}
                        </div>
                        <div className='w-[55%]'>
                            <p className="sf-regular text-[8px] md:text-base break-all" style={{color:templatee?.selectedcolor?.textcolor}}>{business_detaill?.business_phone_1}</p>
                        </div>
                    </div>)}
                    {isEmptyString(business_detaill?.business_phone_2) && (<div className='w-full flex mt-[3px]'>
                        <div className='w-[45%] text-[8px] md:text-base' style={{color:templatee?.selectedcolor?.textcolor2}}>
                            {localizationn?.number_2}
                        </div>
                        <div className='w-[55%]' style={{color:templatee?.selectedcolor?.textcolor}}>
                            <p className="sf-regular text-[8px] md:text-base break-all">{business_detaill?.business_phone_2}</p>
                        </div>
                    </div>)}
                    {isEmptyString(business_detaill?.business_fax) && (<div className='w-full flex mt-[3px]'>
                        <div className='w-[45%] text-[8px] md:text-base' style={{color:templatee?.selectedcolor?.textcolor2}}>
                            {localizationn?.fax}
                        </div>
                        <div className='w-[55%]'>
                            <p className="sf-regular text-[8px] md:text-base break-all" style={{color:templatee?.selectedcolor?.textcolor}}>{business_detaill?.business_fax}</p>
                        </div>
                    </div>)}
                    {isEmptyString(business_detaill?.business_country) && (<div className='w-full flex mt-[3px]'>
                        <div className='w-[45%] text-[8px] md:text-base' style={{color:templatee?.selectedcolor?.textcolor2}}>
                            {localizationn?.country}
                        </div>
                        <div className='w-[55%]'>
                            <p className="sf-regular text-[8px] md:text-base break-all" style={{color:templatee?.selectedcolor?.textcolor}}>{business_detaill?.business_country}</p>
                        </div>
                    </div>)}
                    {isEmptyString(business_detaill?.business_city) && (<div className='w-full flex mt-[3px]'>
                        <div className='w-[45%] text-[8px] md:text-base' style={{color:templatee?.selectedcolor?.textcolor2}}>
                            {localizationn?.city}
                        </div>
                        <div className='w-[55%]'>
                            <p className="sf-regular text-[8px] md:text-base break-all" style={{color:templatee?.selectedcolor?.textcolor}}>{business_detaill?.business_city}</p>
                        </div>
                    </div>)}
                    {isEmptyString(business_detaill?.business_street_1) && (<div className='w-full flex mt-[3px]'>
                        <div className='w-[45%] text-[8px] md:text-base' style={{color:templatee?.selectedcolor?.textcolor2}}>
                            {localizationn?.address_1}
                        </div>
                        <div className='w-[55%]'>
                            <p className="sf-regular text-[8px] md:text-base break-all" style={{color:templatee?.selectedcolor?.textcolor}}>{business_detaill?.business_street_1}</p>
                        </div>
                    </div>)}
                    {isEmptyString(business_detaill?.business_street_2) && (<div className='w-full flex mt-[3px]'>
                        <div className='w-[45%] text-[8px] md:text-base' style={{color:templatee?.selectedcolor?.textcolor2}}>
                            {localizationn?.address_2}
                        </div>
                        <div className='w-[55%]'>
                            <p className="sf-regular text-[8px] md:text-base break-all" style={{color:templatee?.selectedcolor?.textcolor}}>{business_detaill?.business_street_2}</p>
                        </div>
                    </div>)}
                </div>
                <div className='w-[51%] border rounded-[8px] md:rounded-[12px] p-[10px]' style={{borderColor:templatee?.selectedcolor?.bordercolor}}>
                    <h2 className="text-base md:text-xl sf-semibold" style={{color:templatee?.selectedcolor?.secondary}}>Bill to</h2>
                    {isEmptyString(client_detaill?.client_name) && (
                        <div className='w-full flex mt-[3px]'>
                            <div className='w-[45%] text-[8px] md:text-base' style={{color:templatee?.selectedcolor?.textcolor2}}>
                                {localizationn?.client_name}
                            </div>
                            <div className='w-[55%]'>
                                <p className="sf-regular text-[8px] md:text-base break-all" style={{color:templatee?.selectedcolor?.textcolor}}>{client_detaill?.client_name}</p>
                            </div>
                        </div>
                    )}
                    {isEmptyString(client_detaill?.client_email) && (<div className='w-full flex mt-[3px]'>
                        <div className='w-[45%] text-[8px] md:text-base' style={{color:templatee?.selectedcolor?.textcolor2}}>
                            {localizationn?.email}
                        </div>
                        <div className='w-[55%]'>
                            <p className="sf-regular text-[8px] md:text-base break-all" style={{color:templatee?.selectedcolor?.textcolor}}>{client_detaill?.client_email}</p>
                        </div>
                    </div>)}
                    {isEmptyString(client_detaill?.client_phone) && (<div className='w-full flex mt-[3px]'>
                        <div className='w-[45%] text-[8px] md:text-base' style={{color:templatee?.selectedcolor?.textcolor2}}>
                            {localizationn?.number_1}
                        </div>
                        <div className='w-[55%]'>
                            <p className="sf-regular text-[8px] md:text-base break-all" style={{color:templatee?.selectedcolor?.textcolor}}>{client_detaill?.client_phone}</p>
                        </div>
                    </div>)}
                    {isEmptyString(client_detaill?.client_mobile) && (<div className='w-full flex mt-[3px]'>
                        <div className='w-[45%] text-[8px] md:text-base' style={{color:templatee?.selectedcolor?.textcolor2}}>
                            {localizationn?.number_2}
                        </div>
                        <div className='w-[55%]'>
                            <p className="sf-regular text-[8px] md:text-base break-all" style={{color:templatee?.selectedcolor?.textcolor}}>{client_detaill?.client_mobile}</p>
                        </div>
                    </div>)}
                    {isEmptyString(client_detaill?.client_country) && (<div className='w-full flex mt-[3px]'>
                        <div className='w-[45%] text-[8px] md:text-base' style={{color:templatee?.selectedcolor?.textcolor2}}>
                            {localizationn?.country}
                        </div>
                        <div className='w-[55%]'>
                            <p className="sf-regular text-[8px] md:text-base break-all" style={{color:templatee?.selectedcolor?.textcolor}}>{client_detaill?.client_country}</p>
                        </div>
                    </div>)}
                    {isEmptyString(client_detaill?.client_state) && (<div className='w-full flex mt-[3px]'>
                        <div className='w-[45%] text-[8px] md:text-base' style={{color:templatee?.selectedcolor?.textcolor2}}>
                            {localizationn?.state_province}
                        </div>
                        <div className='w-[55%]'>
                            <p className="sf-regular text-[8px] md:text-base break-all" style={{color:templatee?.selectedcolor?.textcolor}}>{client_detaill?.client_state}</p>
                        </div>
                    </div>)}
                    {isEmptyString(client_detaill?.client_city) && (<div className='w-full flex mt-[3px]'>
                        <div className='w-[45%] text-[8px] md:text-base' style={{color:templatee?.selectedcolor?.textcolor2}}>
                            {localizationn?.city}
                        </div>
                        <div className='w-[55%]'>
                            <p className="sf-regular text-[8px] md:text-base break-all" style={{color:templatee?.selectedcolor?.textcolor}}>{client_detaill?.client_city} {client_detaill?.client_zip.trim()!=""&&(" - "+client_detaill?.client_zip)}</p>
                        </div>
                    </div>)}
                    {isEmptyString(client_detaill?.client_address_1) && (<div className='w-full flex mt-[3px]'>
                        <div className='w-[45%] text-[8px] md:text-base' style={{color:templatee?.selectedcolor?.textcolor2}}>
                            {localizationn?.address_1}
                        </div>
                        <div className='w-[55%]'>
                            <p className="sf-regular text-[8px] md:text-base break-all" style={{color:templatee?.selectedcolor?.textcolor}}>{client_detaill?.client_address_1}</p>
                        </div>
                    </div>)}
                    {isEmptyString(client_detaill?.client_address_2) && (<div className='w-full flex mt-[3px]'>
                        <div className='w-[45%] text-[8px] md:text-base' style={{color:templatee?.selectedcolor?.textcolor2}}>
                            {localizationn?.address_2}
                        </div>
                        <div className='w-[55%]'>
                            <p className="sf-regular text-[8px] md:text-base break-all" style={{color:templatee?.selectedcolor?.textcolor}}>{client_detaill?.client_address_2}</p>
                        </div>
                    </div>)}
                </div>
            </div>
            <div className="mt-4 px-3 overflow-hidden">
                <table className="w-full text-[8px] md:text-base">
                    <thead>
                        <tr className="py-3 border-b" style={{backgroundColor:templatee?.selectedcolor?.secondary, borderColor:templatee?.selectedcolor?.bordercolor, color:templatee?.selectedcolor?.tableheadercolor}}>
                            <th className="py-3 px-3 text-left sf-medium">{localizationn?.description}</th>
                            <th className="py-3 px-3 text-center sf-medium">{localizationn?.quantity_up}</th>
                            <th className="py-3 px-3 text-center sf-medium">{localizationn?.unit_price}</th>
                            <th className="py-3 px-3 text-right sf-medium">{localizationn?.total}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {itemss?.map((item,index)=>(
                            <tr key={index} className='border-b text-[9px] md:text-base' style={{borderColor:templatee?.selectedcolor?.bordercolor, color:templatee?.selectedcolor?.textcolor}}>
                                <td className="py-2 px-3 text-left sf-bold">{item?.item_name}</td>
                                <td className="py-2 px-3 text-center sf-regular">{numberbeautify(item?.item_quantity)}{item?.item_type == 'service' ? "/"+item?.item_unit_type : null}</td>
                                <td className="py-2 px-3 text-center sf-regular">{document_currencyy?.symbol}{numberbeautify(item?.item_price)}</td>
                                <td className="py-2 px-3 text-right sf-regular">{document_currencyy?.symbol}{numberbeautify(money_rounding(Number(item?.item_price) * Number(item?.item_quantity)))}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className='w-full flex justify-between mt-2 md:mt-5'>
                <div className='w-1/2 flex flex-col justify-end items-start' style={{color:templatee?.selectedcolor?.textcolor}}>
                    {document_note.trim()!==""&&document_note}
                </div>
                <div className='w-1/2 px-3'>
                    <div className='w-full flex justify-end py-[5px] px-1'>
                        <p className='w-1/2 text-left sf-medium text-[8px] md:text-base' style={{color:templatee?.selectedcolor?.textcolor}}>{localizationn?.sub_total}</p>
                        <p className='w-1/2 text-right sf-semibold text-[8px] md:text-base' style={{color:templatee?.selectedcolor?.textcolor}}>{document_currencyy?.symbol}
                        {
                            numberbeautify(
                            money_rounding(
                                itemss?.reduce((total, item) => total + (Number(item.item_price) * Number(item.item_quantity)), 0)
                            )
                            )
                        }</p>
                    </div>
                    <div className='w-full flex justify-end py-[5px] px-1'>
                        <p className='w-1/2 text-left sf-medium text-[8px] md:text-base' style={{color:templatee?.selectedcolor?.textcolor}}>{localizationn?.discount}: {discount} {discount_type == 'percent' ? '%' : document_currencyy?.symbol}</p>
                        <p className='w-1/2 text-right sf-semibold text-[8px] md:text-base' style={{color:templatee?.selectedcolor?.textcolor}}>{document_currencyy?.symbol}
                        {discount_type=='percent'?
                            numberbeautify(money_rounding(itemss?.reduce((total, item) => Number(total) + ((Number(item.item_price) * Number(item.item_quantity) * (Number(discount) / 100))),0))):
                            numberbeautify(money_rounding(discount))
                        }</p>
                    </div>
                    <div className='w-full flex justify-end py-[5px] px-1'>
                        <p className='w-1/2 text-left sf-medium text-[8px] md:text-base' style={{color:templatee?.selectedcolor?.textcolor}}>{tax_label}: {tax_amount}%</p>
                        <p className='w-1/2 text-right sf-semibold text-[8px] md:text-base' style={{color:templatee?.selectedcolor?.textcolor}}>{document_currencyy?.symbol}
                            {(() => {
                                const items = itemss || [];
                                const discountType = discount_type;
                                const discountValue = Number(discount) || 0;
                                // Calculate total of all items
                                const totalAmount = items.reduce(
                                    (total, item) => total + (Number(item.item_price) * Number(item.item_quantity)),
                                    0
                                );
                                // Calculate discount
                                const discountAmount = discountType === 'percent'
                                    ? (totalAmount * discountValue / 100)
                                    : discountValue;
                                // Calculate the total after discount
                                const totalAfterDiscount = totalAmount - discountAmount;
                                // Calculate the proportion of discount for each item
                                const discountRatio = totalAmount > 0 ? discountAmount / totalAmount : 0;
                                // Calculate tax only on taxable items after proportional discount
                                const taxableAmount = items.reduce(
                                    (total, item) => {
                                    if (item.item_tax_state) {
                                        const itemTotal = Number(item.item_price) * Number(item.item_quantity);
                                        const itemDiscount = itemTotal * discountRatio;
                                        return total + (itemTotal - itemDiscount);
                                    }
                                    return total;
                                    },
                                    0
                                );
                                const taxTotal = taxableAmount * (Number(tax_amount) / 100);
                                return numberbeautify(money_rounding(taxTotal));
                                })()}
                        </p>
                    </div>
                    <div className='w-full flex justify-end py-[5px] px-1 border-t' style={{borderColor:templatee?.selectedcolor?.secondary}}>
                        <p className='w-1/2 text-left sf-semibold text-[13px] md:text-lg' style={{color:templatee?.selectedcolor?.secondary}}>{localizationn?.total}</p>
                        <p className='w-1/2 text-right sf-semibold text-[13px] md:text-lg' style={{color:templatee?.selectedcolor?.secondary}}>{document_currencyy?.symbol}
                            {(() => {
                                const items = itemss || [];
                                const discountType = discount_type;
                                const discountValue = Number(discount) || 0;
                                // Calculate subtotal
                                const subtotal = items.reduce(
                                    (total, item) => total + (Number(item.item_price) * Number(item.item_quantity)),
                                    0
                                );
                                // Apply discount to subtotal
                                const discountt = discountType === 'percent'
                                    ? (subtotal * discountValue / 100)
                                    : discountValue;
                                const subtotalAfterDiscount = subtotal - discountt;
                                // Calculate how much of the discounted subtotal is taxable
                                const taxableRatio = subtotal > 0 ? subtotalAfterDiscount / subtotal : 0;
                                // Calculate tax only on taxable items after proportional discount
                                const taxTotal = items.reduce(
                                    (total, item) => {
                                    if (item.item_tax_state) {
                                        const itemTotal = Number(item.item_price) * Number(item.item_quantity);
                                        const itemAfterDiscount = itemTotal * taxableRatio;
                                        return total + (itemAfterDiscount * (Number(tax_amount) / 100));
                                    }
                                    return total;
                                    },
                                    0
                                );
                                const totalAfterDiscount = subtotalAfterDiscount + taxTotal;
                                return numberbeautify(money_rounding(totalAfterDiscount));
                                })()}
                        </p>
                    </div>
                    {signature.trim()&&(
                        <div className='mt-[10px] flex flex-col items-center'>
                            <img src={signature} className="scale-[0.8]" contentFit="contain" />
                            <p className="sf-semibold -mt-3 text-[9px] md:text-base break-all" style={{color:templatee?.selectedcolor?.textcolor}}>{signature_name}</p>
                        </div>
                    )}
                </div>
            </div>
            <div className='w-full h-52' />
        </div>
    )
}

export default Modern_template_5